import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {CurrencyService} from '../../services/currency.service';

@Pipe({name: 'money'})
export class MoneyPipe implements PipeTransform {

  constructor(private currencyService: CurrencyService,
              private currencyPipe: CurrencyPipe) {
  }

  transform(input: any, currencySlug: string, fractionSize: number = 2, noDecimalsIfPossible?: boolean): any {
    const currency = this.currencyService.getBySlug(currencySlug) || this.currencyService.findCurrencies()[0];

    if (currency.symbol) {

      let inputFloat = 0;
      try {
        inputFloat = parseFloat(input);
      } catch (e) { }
      if (noDecimalsIfPossible && Math.floor(inputFloat) === inputFloat) {
        fractionSize = 0;
      }

      if (currency.symbol.length > 1) {
        const displayAmount = (Math.floor(inputFloat * Math.pow(10, fractionSize)) / Math.pow(10, fractionSize)).toFixed(fractionSize);
        return displayAmount + ' ' + currency.symbol;
      } else {
        return this.currencyPipe.transform(input, currency.slug.toUpperCase(), 'symbol', `1.${fractionSize}-${fractionSize}`);
      }
    } else {
      if (noDecimalsIfPossible && Math.floor(input) === input) {
        fractionSize = 0;
      }
      return this.currencyPipe.transform(input, currency.slug.toUpperCase(), 'symbol', `1.${fractionSize}-${fractionSize}`);
    }
  }

}
